

exports.__esModule = true;
exports.getClientMetadataID = getClientMetadataID;

var _squid = require('squid');

function getClientMetadataID(defaultID) {
    if (window.xprops && window.xprops.clientMetadataID) {
        return window.xprops.clientMetadataID;
    } else if (_squid.$util.param('client-metadata-id')) {
        return _squid.$util.param('client-metadata-id');
    } else {
        return defaultID;
    }
}

_squid.$util;


//////////////////
// WEBPACK FOOTER
// ./js/lib/metadata.js
// module id = ./js/lib/metadata.js
// module chunks = main-code-split